/**
 * Module-level tour runtime flag.
 *
 * Read OUTSIDE React by the Apollo authLink (App.js) to add the
 * `x-bdr-tour: 1` peek header while a walkthrough is running — the server then
 * serves emails / text threads without marking them read (registry §36.4).
 *
 * It is a plain variable, not React state, so a link callback never sees a
 * stale closure. It lives in memory only: a reload always starts with no tour,
 * so a stuck flag can never survive a refresh.
 */
let active = false;

export const isTourActive = () => active;

export const setTourActive = (value) => {
  active = !!value;
};
